<template>

    <section id="form-edit">

      <div class="box is-shadowless">

        <div class="is-pulled-right">
          <span class="tag is-dark is-large">{{ form.status }}</span>
        </div>

        <h1 class="title is-3">Inspection <span id="form-id">{{ form.id_alt }}</span> <small id="form-type" class="has-text-grey-lighter">{{ form.type.text }}</small></h1>

        <div class="mb-20" style="position: relative;">

          <!-- <div v-if=" ! map_mode" :style="{height: aklcAssetMapConfig.height, position: 'relative'}">
            <b-loading :is-full-page="false" :active="true"></b-loading>
          </div> -->

          <!-- <aklc-asset-map v-else-if="map_mode == 'ASSET_EXISTING'" :config="aklcAssetMapConfig" @postmessage="onReceivedAklcAssetMapPostMessage"></aklc-asset-map> -->
          <!-- <google-asset-map v-else-if="map_mode == 'ASSET_NEW'" v-bind="googleAssetMapConfig" @coordinates="onReceivedGoogleAssetMapCoordinates"></google-asset-map> -->

          <!-- <div v-if="map_mode == 'ASSET_EXISTING' && assetsAroundClickPoint.length" class="panel is-default assets-nearest-click">
            <div class="panel-heading">Assets Nearby</div>
            <a v-for="a in assetsAroundClickPoint"
              :key="`nearby_asset_${a.properties.asset_id}`"
              @click="onSelectOfferedAsset(a)"
              :class="{ 'is-active': a.properties.asset_id == assetIdForClickPoint }"
              class="panel-block">
                <span class="panel-icon">
                  <i class="fa fa-chevron-right"></i>
                </span>
                {{ describeAssetFeature(a) }}
            </a>
            <div class="panel-block">
              <button class="button is-danger is-fullwidth is-uppercase"
                :disabled="!assetIdForClickPoint"
                @click="onConfirmProximityAssetSelection">
                  Confirm Selection
              </button>
            </div>
          </div>

          <div v-if=" ! map_mode" :style="{height: mapConfig.height, position: 'relative'}">
            <b-loading :is-full-page="false" :active="true"></b-loading>
          </div>
          <leaflet-offline-map
            v-else-if="map_mode == 'ASSET_EXISTING'"
            ref="mapAsset"
            :key="`LEAFLET_ASSET_EXISTING`"
            :config="mapConfig"
            @move-end="onMoveEnd"
            @ready="onMapReady"
            @click-feature="onAssetFeatureClicked"
            @click-map="onAssetCoordinatesClicked">
          </leaflet-offline-map>
          <leaflet-offline-map
            v-else-if="map_mode == 'ASSET_NEW'"
            ref="mapAssetNew"
            :key="`LEAFLET_ASSET_NEW`"
            @ready="onMapReady"
            :config="mapConfigNewAsset"
            @click-map="onFreeClickCoordinates">
          </leaflet-offline-map>

          <br>

          <div v-if="map_mode" class="tabs is-centered is-toggle">
            <ul>
              <li :class="{'is-active': map_mode == 'ASSET_EXISTING'}" @click.prevent.stop="map_mode = 'ASSET_EXISTING'">
                <a>Select Asset</a>
              </li>
              <li :class="{'is-active': map_mode == 'ASSET_NEW'}" @click.prevent.stop="map_mode = 'ASSET_NEW'">
                <a>New Asset</a>
              </li>
            </ul>
          </div> -->

          <forms-edit-map
            :center="mapCenter"
            :selected.sync="selectedAsset"
            :contract-id="form.order.contract_id"
            :view-only="!!form.order_operation_id"
            v-if="form.order_operation_id ? true : allowedAssetCodes.length"
          />

          <div class="mt-1">
            <b-button
              type="is-info"
              :disabled="!isSelectedAssetValid"
              @click="selectAsset"
            >
                SELECT ASSET
              </b-button>
          </div>

        </div>

        <form class="form" @submit.prevent="onSubmit">

          <div class="box">

            <div class="columns is-mobile is-multiline">

              <!--
              <div class="column is-half">
                <div class="field">
                  <label class="label">Inspected On</label>
                  <datetime value-zone="Pacific/Auckland" zone="Pacific/Auckland" type="datetime" input-class="input" v-model="form.completed_at"></datetime>
                </div>
              </div>
              -->

              <div class="column is-half">
                <div class="field">
                  <label class="label">Asset ID</label>
                  <div class="control">
                    <b-input :value="form.asset ? form.asset.thirdPartyCode : ''" readonly></b-input>
                  </div>
                </div>
              </div>

              <div class="column is-half">

                <!-- <div class="field">
                  <label class="label">Asset class <span class="has-text-danger">*</span></label>
                  <div class="control">
                      <b-field>
                          <b-select expanded @input="updateForm(form)" v-model="form.asset_class">
                              <option :value="null">Please Select</option>
                              <option
                                  :key="option.value"
                                  :value="option.value"
                                  v-for="(option) in assetClasses">{{option.text}}</option>
                          </b-select>
                      </b-field>
                  </div>
                </div> -->

                <div class="field">
                  <label class="label">Asset Class</label>
                  <div class="control">
                    <b-input :value="form.asset && form.asset.code ? form.asset.code.name : ''" readonly></b-input>
                  </div>
                </div>
              </div>

              <div class="column is-half">
                <div class="field">
                  <label class="label">Inspected By</label>
                  <div class="control">
                      <input type="text" class="input" name="" id="" :value="(dForm.inspector && dForm.inspector.id) ? `${dForm.inspector.firstName} ${dForm.inspector.lastName}` : ''" readonly>
                  </div>
                </div>
              </div>

              <!-- <div class="column is-half">
                <div class="field">
                  <label class="label">Asset ID</label>
                  <div class="control">
                      <div class="field">
                        <input type="text" class="input" v-model="form.asset_code" @input="updateForm(form)" readonly>
                      </div>
                  </div>
                </div>
              </div>

              <div class="column is-half">

                <div class="field">
                  <label class="label">Asset Latitude</label>
                  <div class="control">
                      <div class="field">
                        <input type="text" class="input" v-model="form.asset_lat" @input="updateForm(form)" readonly>
                      </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Asset Longitude</label>
                  <div class="control">
                      <div class="field">
                        <input type="text" class="input" v-model="form.asset_lng" @input="updateForm(form)" readonly>
                      </div>
                  </div>
                </div>

              </div> -->

            </div> <!-- .columns -->

          </div> <!-- .box (header questions) -->

          <!-- START container for dynamic questions -->
          <div>

            <div class="columns is-mobile is-multiline">

              <template v-for="(criterion, idx) in criteria">

                <div :key="`${idx}-start`" class="column is-full" v-if="criterion.section_start && !criterion.hidden">
                  <hr style="margin:0" />
                </div>

                <div :key="`${idx}-close`" class="column is-full" v-if="criterion.section_start && !criterion.hidden">
                  <b-button
                    type="is-danger"
                    icon-right="close"
                    @click="hideSection(getSectionGroup(criterion), getSection(criterion))"
                  />
                </div>

                <div :key="idx" :class="`${!criterion.hidden ? 'column is-half' : ''}`" v-show="!criterion.hidden">

                  <div class="box">

                    <label class="label">{{ getCriterionLabel(criterion) }} <span v-if="criterion.mandatory" class="has-text-danger">*</span></label>

                    <b-field v-if="criterion.input_type === dropdown">
                      <b-select :name="criterion.field_name" expanded v-model="criterion.values" :disabled="criterion.disabled" @input="onInput(criterion)">
                        <option
                          :key="option.value"
                          :value="option.value"
                          v-for="option in criterion.input_type_options">{{option.text}}
                        </option>
                      </b-select>
                    </b-field>

                    <b-field v-if="criterion.input_type === multidropdown">
                      <b-select :name="criterion.field_name" multiple expanded v-model="criterion.values" :disabled="criterion.disabled" @input="onInput(criterion)">
                        <option
                          :key="option.value"
                          :value="option.value"
                          v-for="option in criterion.input_type_options">{{option.text}}
                        </option>
                      </b-select>
                    </b-field>

                    <b-field v-if="criterion.input_type === text">
                      <textarea :name="criterion.field_name" rows="5" class="textarea" v-model="criterion.values" :disabled="criterion.disabled" @input="onInput(criterion)"></textarea>
                    </b-field>

                    <b-field v-if="criterion.input_type === text_tag">
                      <textarea
                        v-model="criterion.values"
                        :name="criterion.field_name"
                        rows="5"
                        class="textarea"
                        :disabled="criterion.disabled"
                        @input="onInput(criterion)"
                      
                      />
                    </b-field>

                    <b-field v-if="criterion.input_type === string">
                      <input :name="criterion.field_name" type="text" class="input" v-model="criterion.values" :disabled="criterion.disabled" @input="onInput(criterion)">
                    </b-field>

                    <b-field v-if="criterion.input_type === switch_unix">

                      <!-- @todo - Custom component for switch with non-static checked vs unchecked values -->
                      <!-- (buefy switch can't handle false vs changing integer for unix timestamp as true) -->
                      <!-- <label :class="`switch is-medium ${criterion.disabled ? 'is-disabled' : ''}`" :disabled="criterion.disabled" @click.prevent.stop="toggleUnixSwitch(criterion)">
                        <input :name="criterion.field_name" type="checkbox" :checked="criterion.values ? true : false" :disabled="criterion.disabled">
                          <span class="check is-success"></span>
                          <span class="control-label"></span>
                      </label> -->

                      <b-switch
                        :value="criterion.values ? true : false"
                        :name="criterion.field_name"
                        type="is-success"
                        size="is-medium"
                        :rounded="false"
                        :disabled="criterion.disabled"
                        @input="toggleUnixSwitch(criterion)"
                      />

                    </b-field>

                    <b-field v-if="criterion.input_type === switch_tag">

                      <b-switch
                        :value="criterion.values ? true : false"
                        :name="criterion.field_name"
                        type="is-success"
                        size="is-medium"
                        :rounded="false"
                        :disabled="criterion.disabled"
                        @input="toggleTagSwitch(criterion)"
                      />

                    </b-field>

                    <div class="field" v-if="criterion.input_type === upload">

                      <b-field class="file">
                        <b-upload :name="criterion.field_name" native multiple id="fileUpload" @input="onFileUpload($event, criterion.form_criteria_id, idx)">
                            <a class="button is-info">
                                <b-icon icon="upload"></b-icon>
                                <span>Click to upload</span>
                            </a>
                        </b-upload>
                      </b-field>

                      <div class="columns is-multiline is-mobile" v-if="criteriaFiles[idx].length > 0">
                        <div class="column is-half-mobile is-one-fifth-tablet"
                            v-for="(file, id) in criteriaFiles[idx]"
                            :key="id">
                            <a :href="file.full_url">
                              <img :src="file.full_url" alt="">
                            </a>
                            <button class="button is-danger" @click.prevent="onDeleteFile(file.id)"><i class="fa fa-trash"></i></button>
                        </div>
                      </div>

                    </div> <!-- .field (with upload image grid) -->

                  </div> <!-- .box (around each dynamic question) -->

                </div> <!-- .column (for each dynamic question) -->

                <div :key="`${idx}-addsection`" class="column is-full" v-if="criterion.section_last">
                  <b-button
                    icon-left="plus"
                    :disabled="isSectionGroupVisible(criterion)"
                    @click="() => showSection(getSectionGroup(criterion))"
                  >
                    Add section
                  </b-button>
                </div>

                <div :key="`${idx}-end`" class="column is-full" v-if="criterion.section_end && !criterion.hidden">
                  <hr style="margin:0" />
                </div>

                <!-- Temporary solution to force columns to wrap after certain criterion -->
                <div v-if="['86', '84', '71', '6', '90', '47', '50', '53', '56', '59', '85', '72', '75', '66', '91'].indexOf(criterion.form_criteria_id) >= 0" class="column is-half"></div>

              </template>

            </div> <!-- .columns (around all dynamic questions) -->

          </div> <!-- simple container wrapping the collection of dynamic questions -->

          <div class="box" style="margin-top: 1.5rem;">

            <div class="columns">

              <div class="column is-half">

                <div class="field">
                  <label class="label" for="notes">General Comments</label>
                  <div class="control">
                      <textarea @input="updateForm(form)" id="notes" cols="30" rows="4" class="textarea" v-model="form.notes"></textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label" for="engineer_required">Council Engineer Required <span class="has-text-danger">*</span></label>
                  <div class="control">
                      <div class="select is-fullwidth">
                        <select id="engineer_required" v-model="form.engineer_required" @input="updateForm(form)">
                          <!-- @todo - The engineer required column should be nullable -->
                          <option :value="null">Please Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                  </div>
                </div>

              </div>

              <div class="column is-half">

                <div class="field">
                  <label class="label" for="hs_notes">Health &amp; Safety Issues</label>
                  <div class="control">
                      <textarea @input="updateForm(form)" id="hs_notes" cols="30" rows="4" class="textarea" v-model="form.hs_notes"></textarea>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <hr>

          <div class="field">
            <div class="is-pulled-right">
              <button type="button"
                @click.prevent="onSaveAsDraft()"
                v-if="form.status !== 'PUBLISHED'"
                :disabled="formIsBusy"
                class="button is-info is-large"
                :class="{ 'is-loading': formIsBusy }">
                  <i class="fa fa-save"></i>
                  &nbsp;
                  Save Draft
                </button>
              <button
                type="submit"
                tabindex="-1"
                :disabled="form.status === 'PUBLISHED' || formIsBusy"
                class="button is-success is-large"
                :class="{ 'is-loading': formIsBusy }">
                  <i class="fa fa-check"></i>
                  &nbsp;
                  Publish
              </button>
            </div>
            <div>
              <button @click.prevent="$router.push({ path: '/forms'});" class="button is-large"> <i class="fa fa-arrow-left"></i> &nbsp; Back</button>
            </div>
          </div>

        </form>

      </div> <!-- .box -->

    </section>

</template>

<style scoped>
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.p-15 {
  padding: 8px 15px;
}
</style>
<script>
import { Statuses } from "@/helpers/statuses-options";
import { FormService } from "@/services/form.service.js";
import { FileService } from "@/services/file.service.js";
import { AssetService } from "@/services/asset.service.js";
import { FormCriteriaTransformer } from "@/helpers/forms/form-criteria.transformer";
import { FormResponseTransformer } from "@/helpers/forms/form-response.transformer";
import { FormTransformer } from "@/helpers/forms/form.transformer";
import { CriteriaActions } from "@/helpers/forms/form-criteria-actions";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { AssetClass } from "@/helpers/asset-class-options.js";
import EventUtil from "@/utils/event.util.js";
import proj4 from '@/wrappers/proj4.js';
import GoogleAssetMap from "@/components/GoogleAssetMap.vue";
import AklcAssetMap from "@/components/AklcAssetMap.vue";
import LeafletOfflineMap from "@/components/LeafletOfflineMap";
import FormsEditMap from "./partials/map";
import * as moment from "moment";
import _ from "lodash";

import turfDistance from '@turf/distance';
import { point as turfPoint } from '@turf/helpers';

export default {
  name: "form-edit",
  components: {
    "aklc-asset-map": AklcAssetMap,
    "google-asset-map": GoogleAssetMap,
    "leaflet-offline-map": LeafletOfflineMap,
    FormsEditMap
  },
  data() {
    return {
      environment: "",
      map_mode: "", // or "ASSET_EXISTING" or ASSET_NEW"
      aklcAssetMapConfig: {
        height: "500px",
        asset_id: "",
        asset_type: "",
        latitude: "",
        longitude: ""
      },
      googleAssetMapConfig: {
        assetLatitude: "",
        assetLongitude: "",
        centerLatitude: "",
        centerLongitude: "",
        mapHeight: "500px"
      },
      statuses: Statuses.options(),
      assetClasses: AssetClass.options(),
      files: [],
      filePath: process.env.API_URL + "/uploads/",
      multidropdownDefault: [],
      asset_code: "",
      dForm: {inspector: {}, order: {}},
      // The debounced updateForm function needs to be able to calculate
      // when it is safe to start saving changes - and it detects the
      // initial population from the server as change made by user.
      initialLoadCompletedAt: '',
      form: {
        type: {type: "", text: ""},
        completed_at: moment().toISOString(),
        completed_by: "",
        asset_id: null, // since StormPort now has asset data locally
        asset_name: "",
        asset_class: null,
        asset_code: "",
        notes: "",
        hs_notes: "",
        file: "",
        status: "DRAFT",
        description: "",
        responses: [],
        // GPS-related defaults
        asset_lat: "",
        asset_lng: "",
        start_datetime: "",
        device_lat_start: "",
        device_lng_start: "",
        device_accuracy_start: "",
        finish_datetime: "",
        engineer_required: null
      },
      formBusyCounter: 0, // counter for ajax updates
      criteria: [],
      criteriaFiles: [],
      form_id: this.$route.params.id,
      dropdown: CriteriaActions.DROPDOWN,
      multidropdown: CriteriaActions.MULTIDROPDOWN,
      upload: CriteriaActions.UPLOAD,
      text: CriteriaActions.TEXT,
      text_tag: CriteriaActions.TEXT_TAG,
      string: CriteriaActions.STRING,
      switch_unix: CriteriaActions.SWITCH_UNIX,
      switch_tag: CriteriaActions.SWITCH_TAG,
      assetsGeojson: {},
      lastActiveFeatureId: null,
      lastKnownMapCenter: null, // we can watch this for fetching assets
      mapConfig: {
        center: {
          // Default can be overwritten as soon as we have
          // coords from the DRAFT form or on switching
          // map mode if a sensible center available.
          lat: -36.858411,
          lng: 174.760959
        },
        zoom: 19,
        height: '500px',
        markerOnClick: false,
        hasOfflineControl: false
      },
      lastClickPoint: null, // we use this to find assets close to the user's click
      assetIdForClickPoint: null,
      selectedAsset: null,
      // form.asset_code must not be submitted as part of the inspection form
      selectedAssetCode: "",
      mapCenter: null,
      allowedAssetCodes: [],
    };
  },
  computed: {
    mapConfigNewAsset() {
      // Mostly the same as this.mapConfig (for selecting existing asset)
      const baseConfig = this.mapConfig;
      return Object.assign(
        {},
        baseConfig,
        {
          markerOnClick: true,
        }
      );
    },
    assetsAroundClickPoint() {
      let assets = [];
      let stripped = []; // objects with just asset ID and distance for looping
      let point = this.lastClickPoint;
      if (point && this.assetsGeojson && this.assetsGeojson.features && this.assetsGeojson.features.length) {
        this.assetsGeojson.features.forEach(a => {
          const id = a.properties.asset_id;
          const compare = a.properties.start_coordinates;
          const from = turfPoint([point.lng, point.lat]);
          const to = turfPoint([compare.lng, compare.lat]);
          const distance = turfDistance(from, to, { units: 'kilometers' });
          stripped.push({ id, distance });
        });
        stripped.sort((a, b) => a.distance - b.distance);
        stripped = stripped.slice(0, 5);
        stripped.forEach(subset => {
          let feature = this.assetsGeojson.features.find(item => item.properties.asset_id == subset.id);
          if (feature) {
            feature = _.cloneDeep(feature);
            feature.properties.distance = subset.distance;
            assets.push(feature);
          }
        });
      }
      return assets;
    },
    // mapCenter() {
    //   if (this.form.order && this.form.order.loggedLat && this.form.order.loggedLng) {
    //     return {
    //       lat: this.form.order.loggedLat,
    //       lng: this.form.order.loggedLng
    //     }
    //   }

    //   return undefined;
    // },
    isSelectedAssetValid() {
      // if (!this.selectedAsset || !this.form.asset_class) return false;
      // return this.form.asset_class === this.selectedAsset.code.code;
      if (!this.selectedAsset) return false;
      return this.allowedAssetCodes.map(code => code.id).includes(this.selectedAsset.code.id);
    },
    formIsBusy() {
      return this.formBusyCounter > 0;
    }
  },
  watch: {
    map_mode(next) {
      // To make the map(s) center on the last selected asset/coordinates
      // For now we only want to center on switching map, not on click
      // since this could trigger a map move and reload the assets.
      // (currently having trouble restoring asset info popup)
      if (this.form.asset_lat) {
        this.$set(this.$data.mapConfig, 'center', {
          lat: this.form.asset_lat,
          lng: this.form.asset_lng,
        });
        if (next == 'ASSET_EXISTING') {
          // @todo - this is getting lost due to move-end event firing
          // when map modes change and so we have null coordinates.
          this.lastClickPoint = {
            lat: this.form.asset_lat,
            lng: this.form.asset_lng
          };
        }
      }
    },
    lastKnownMapCenter: _.debounce(
      function (latlng) {
        const vm = this;
        // At the time of writing, this is only relevant for ASSET_EXISTING map mode
        if (vm.$data.map_mode == 'ASSET_EXISTING') {
          const mapComponent = vm.$refs.mapAsset;
          const zoom = mapComponent.map.getZoom();
          // Don't currently have a decent way to remove previously rendered
          // layers so we'll dig right into the child component to do this.
          mapComponent.layers.vectorGrids.forEach(layer => {
            mapComponent.map.removeLayer(layer);
          });
          // Deactivate any selected features or open feature popups
          mapComponent.clearActiveFeature();
          if (mapComponent.activeFeaturePopup) {
            mapComponent.activeFeaturePopup.remove();
          }
          if (zoom >= 17) {
            let lastActiveFeature = null;
            vm.fetchAssetsAroundCenter({ coordinates: latlng })
              .then(data => {
                // Since we're going to convert CPIT Points to Polygons, we need
                // to be able to keep the original coordinates for later. We
                // can only submit one lat & lng pair per inspection form.
                // (and Polygons, LineString etc. have multiple points)
                data.features = data.features.map(item => {
                  const transformed = vm.transformFeature(item); // should copy unmodified coordinates to properties
                  if (transformed.properties.asset_id == vm.lastActiveFeatureId) {
                    lastActiveFeature = transformed;
                  }
                  return transformed;
                });
                vm.assetsGeojson = Object.freeze(data);

                // const x = mapComponent.loadGeoJson(data, 'asset_id', null, null, vm.assetPopup);
                const x = mapComponent.loadGeoJson(data, 'asset_id', null, null, null);
                if (lastActiveFeature) {
                  /*
                  // DISABLED because it triggers events like collecting coordinates
                  // as if the user had really just manually clicked the feature.
                  // (need to come up with another way to only show the popup)
                  vm.$refs.mapAsset.clickFeature(vm.lastActiveFeatureId, null, {
                    latLng: latlng,
                    content: vm.assetPopup(lastActiveFeature.properties),
                  });
                  */
                  // For now we'll just highlight the active feature but
                  // this currently won't include a hover/click popup.
                  vm.$refs.mapAsset.setActiveFeature(lastActiveFeature.properties.asset_id);
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        }
      },
      1500,
      { trailing: true }
    ),
    assetsAroundClickPoint(nextAssets) {
      // Try to determine a sensible asset by default when a user clicks
      // on the map (did user click directly on feature or map space?)
      if (nextAssets.length) {
        // If the user successfully clicked directly on a feature then we
        // should have its asset_id available to select automatically.
        // (the user will still be able to switch to nearby assets)
        let asset;
        if (this.assetIdForClickPoint) {
          asset = nextAssets.find(a => a.properties.asset_id == this.assetIdForClickPoint);
        }
        if ( ! asset) {
          asset = nextAssets[0]; // closest assuming assetsAroundClickPoint are sorted by distance from click
        }
        let assetId = asset ? asset.properties.asset_id : null;
        if (this.assetIdForClickPoint != assetId) {
          this.assetIdForClickPoint = assetId;
        }
      }
    },
    assetIdForClickPoint(nextAssetId) {
      if (this.$refs.mapAsset) {
        this.$refs.mapAsset.setActiveFeature(nextAssetId);
      }
    }
  },
  mounted() {

    const vm = this;

    this.getAllowedAssetCodes();

    this.$data.environment = process.env.ENVIRONMENT || "production";

    this.loadForm()
      .then(async form => {

        if (this.form.asset_lat && this.form.asset_lng) {
          vm.mapConfig.center.lat = this.form.asset_lat;
          vm.mapConfig.center.lng = this.form.asset_lng;
        }

        vm.$data.initialLoadCompletedAt = Date.now();

        // vm.loadMapForForm();

        // Use user's location if allowed and no selected asset
        if (!this.selectedAsset) {
          this.$store.dispatch("routeLoading");
          const userLocation = await this.attemptLocation({ timeout: 10000 });
          if (userLocation) {
            this.mapCenter = {
              lat: userLocation.coords.latitude,
              lng: userLocation.coords.longitude
            };
          }
          this.$store.dispatch("routeLoading", false);
        }
    });

    this.loadFormCriteria();
  },
  methods: {
    getCriterionLabel(criterion) {
      switch (criterion.input_type) {
        case "switch_tag":
          return (criterion.field_name || "").substring(4);
        default:
          return criterion.field_label;
      }
    },
    getLocation(options) {

      this.$buefy.toast.open('Collecting location...');

      return this.$gps.getLocation(options);
    },
    attemptLocation(options) {

      // This function attempts to get a location and resolves with either
      // the position object or simply false if location lookup failed.
      // (for when location should be attempted but is not required)
      return new Promise((resolve, reject) => {

        this.getLocation(options)
          .then(position => {

            return resolve(position);
          })
          .catch(err => {

            return resolve(false);
          });
      });
    },
    loadForm() {
      return FormService.show(this.form_id, {includes: 'inspector,order,asset'}).then(res => {
        // this.form = FormTransformer.transform(res.data);
        this.form = JsonDenormalizer.denormalize(res);
        // this.form.asset_id = this.form.asset ? this.form.asset.id : "";
        this.selectedAsset = this.form.asset;
        this.selectAsset(false); // Populate asset fields on load
        this.selectedAssetCode = this.form.asset ? this.form.asset.thirdPartyCode : "";
        if (this.form.status == "SUBMITTED") {
          // this.$router.push({ name: "form-list" });
          this.$router.push({
            name: "form-show",
            params: { id: this.form_id }
          });
        }
        if (!this.form.completed_at) {
          this.form.completed_at = moment().toISOString();
        }
        this.asset_code = this.form.asset_code;
        this.$data.dForm = JsonDenormalizer.denormalize(res);
        Promise.resolve(this.form);
      });
    },
    loadMapForForm() {

      /**
       * This is a big one, written in a bit of a hurry.
       *
       * 1. Determine which map to show depending on existing form data
       *  (is there an existing asset selected or new asset marked?)
       *
       * 2. Potentially get user's coordinates if no asset data available
       *  (must wait for coordinates to resolve before loading the map)
       *
       * 3. Update AKLC and Google asset map settings with known data.
       *  (convert GPS coordinates to NZTM for AKLC map as needed)
       *
       * 4. Finally set the map mode which will trigger map loading.
       */

      const vm = this;
      const { form } = vm.$data;

      let merge_aklc = {asset_id: form.asset_code, asset_type: form.asset_class};
      let merge_goog = {assetLatitude: form.asset_lat, assetLongitude: form.asset_lng};
      let map_mode = (form.asset_lat && ! form.asset_code) ? 'ASSET_NEW' : 'ASSET_EXISTING';
      let coord_lookup = true;

      // If we have coordinates available, we need to convert them for use by council map
      if (form.asset_lat && form.asset_lng) {

        const converted = proj4('GPS', 'NZTM', [parseFloat(form.asset_lng), parseFloat(form.asset_lat)]);

        merge_aklc = _.extend(merge_aklc, {latitude: converted[1], longitude: converted[0]});
      }

      coord_lookup = (form.status == 'SUBMITTED') ? false : coord_lookup;
      coord_lookup = (form.asset_code) ? false : coord_lookup;
      coord_lookup = (form.asset_lat) ? false : coord_lookup;

      const callback = function() {

        vm.$data.aklcAssetMapConfig = _.extend({}, vm.$data.aklcAssetMapConfig, merge_aklc);
        vm.$data.googleAssetMapConfig = _.extend({}, vm.$data.googleAssetMapConfig, merge_goog);
        vm.$data.map_mode = map_mode;
      };

      const p = new Promise((resolve, reject) => {

        if (coord_lookup) {

          vm.getLocation({accuracy: 100, timeout: (vm.$store.state.environment == 'local') ? 3000 : 20000})
            .then(position => {

              return resolve(position);
            })
            .catch(err => {

              return reject(err);
            })
        }
        else return resolve(false);
      });

      p.then(position => {

        if (position) {

          vm.$data.mapConfig = _.extend({}, vm.$data.mapConfig, {
            center: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          });

          // AKLC map uses NZTM coordinates :(
          const converted = proj4('GPS', 'NZTM', [position.coords.longitude, position.coords.latitude]);

          merge_aklc['latitude'] = converted[1];
          merge_aklc['longitude'] = converted[0];
          merge_goog['centerLatitude'] = position.coords.latitude;
          merge_goog['centerLongitude'] = position.coords.longitude;
        }

        callback();
      })
      .catch(err => {

        vm.$buefy.toast.open({message: `Geolocation failed: ${err.message}`, type: 'is-warning'});

        callback();
      });
    },
    getSectionGroup(criterion) {
      const match = (criterion ? criterion.field_name : "").match(/.+_group(\d+)/);
      return match ? parseInt(match[1]) : null;
    },
    getSection(criterion) {
      const match = (criterion ? criterion.field_name : "").match(/.+_section(\d+)/);
      return match ? parseInt(match[1]) : null;
    },
    // Get the first empty section
    getEmtpySection(group) {
      const regex = new RegExp(`.+_group${group}_section`);
      let groupCriteria = this.criteria.filter(v => v.field_name.match(regex));
      for (let x = 0; x < groupCriteria.length; x++) {
        if (groupCriteria[x].hidden && this.isSectionEmpty(groupCriteria[x])) {
          return this.getSection(groupCriteria[x]);
        }
      }
      return null;
    },
    // Check if all sections are visible/opened
    isSectionGroupVisible(criterion) {
      const group = this.getSectionGroup(criterion);
      const regex = new RegExp(`.+_group${group}_section`);
      let groupCriteria = this.criteria.filter(v => v.field_name.match(regex));
      for (let x = 0; x < groupCriteria.length; x++) {
        // const isSectionEmpty = this.isSectionEmpty(groupCriteria[x - 1]);
        // if (isSectionEmpty) {
        //   return false;
        // }
        if (groupCriteria[x].hidden) {
          return false;
        }
      }
      return true;
    },
    isSectionEmpty(criterion) {
      const group = this.getSectionGroup(criterion);
      const section = this.getSection(criterion);
      const regex = new RegExp(`.+_group${group}_section${section}`);
      const sectionCriteria = this.criteria.filter(v => v.field_name.match(regex));
      return sectionCriteria.every(v => {
        switch (v.input_type) {
          case "dropdown":
            return v.values == "please_select";
          default:
            return !v.values;
        }
      });
    },
    showSection(group, section = null) {
      if ( ! section) {
        section = this.getEmtpySection(group);
      }
      const regex = new RegExp(`.+_group${group}_section${section}`);
      this.criteria.forEach(v => {
        if (v.field_name.match(regex)) {
          v.hidden = false;
        }
      });
    },
    hideSection(group, section) {
      const regex = new RegExp(`.+_group${group}_section${section}`);
      this.criteria.forEach(v => {
        if (v.field_name.match(regex)) {
          v.hidden = true;
          // Empty section
          switch (v.input_type) {
            case "dropdown":
              v.values = "please_select";
              break;
            default:
              v.values = "";
          }
        }
      });
      this.updateForm(this.form);
    },
    loadFormCriteria() {
      FormService.listFormCriteria(this.form_id).then(res => {

        const criteria = FormCriteriaTransformer.transformArray(res.data);
        this.criteria = _.sortBy(criteria, ['display_order']);

        let section = null;
        let insideSection = false;
        this.criteria.forEach((v, i) => {
          // Sections - Hides empty sections
          // const match = v.field_name.match(/.+_section(\d+)/);
          const criterion_section = this.getSection(v);
          if (criterion_section) {
            if ( ! insideSection) {
              insideSection = true;
              v.section_start = true;
            } else {
              const next_criterion = this.criteria[i + 1];
              // const next_field_name = next_criterion ? next_criterion.field_name : "";
              // const next_match = next_field_name.match(/.+_section(\d+)/);
              // const next_section = next_match ? next_match[1] : null;
              const next_section = this.getSection(next_criterion);
              if (section != next_section) {
                insideSection = false;
                v.section_end = true;
              }
              // Last section
              if ( ! next_section) {
                v.section_last = true;
                this.showSection(this.getSectionGroup(v));
              }
            }
            // v.hidden = this.isSectionEmpty(v);
            this.$set(this.criteria[i], "hidden", this.isSectionEmpty(v));
            section = criterion_section;
          } else {
            if (insideSection) {
              insideSection = false;
              v.section_end = true;
            }
          }

          // Enabled/Disabled
          this.enableChildrenInput(v);
        });

        // We'll keep an array of files mapped to the criteria index
        // (each criteria index will have at least an empty array)
        let data = [];

        this.criteria.forEach((obj, k) => {
          let files = [];

          if (obj.input_type == "upload") {
            if (Array.isArray(obj.values)) {
              obj.values.forEach((form_response, i) => {
                if (Array.isArray(form_response.files))
                  files = files.concat(form_response.files);
              });
            }
          }

          data[k] = files;

          this.criteriaFiles = data;
        });
      });
    },
    onSubmit() {

      const vm = this;

      // Optionally do some basic validation on the UI side
      // (more advanced validation takes place on server)
      const errors = [];

      this.criteria.forEach(item => {
        if (
          (!item.values || item.values == "please_select") &&
          item.mandatory
        ) {
          errors.push(item.field_label + " is required.");
        }
      });

      if (errors.length) {

        EventUtil.$emit('validationErrors', errors);
      }
      else {

        // Populate finish timestamp if not already exising
        // (for future in case we later have "unpublish")
        if ( ! vm.$data.form.finish_datetime) {

          vm.$data.form.finish_datetime = moment().utc().toISOString();
        }

        // Collect and save GPS coordinates on finish
        vm.$store.dispatch('routeLoading');

        const p = new Promise((resolve, reject) => {

          // Temporarily disable GPS collection.
          // return resolve(false);

          // Don't bother if we already have finish coordinates saved from previous publish...
          if ( ! vm.$data.form.device_lat_finish) {

            vm.getLocation({accuracy: 100, timeout: (vm.$store.state.environment == 'local') ? 3000 : 20000})
              .then(position => {

                return resolve(position);
              })
              .catch(err => {

                return resolve(false);
              });
          }
          else return resolve(false);
        });

        p.then(position => {

          if (position) {

            const merge = {
              device_lat_finish: position.coords.latitude,
              device_lng_finish: position.coords.longitude,
              device_accuracy_finish: position.coords.accuracy
            };

            vm.form = _.extend({}, vm.$data.form, merge);
          }

          Object.assign(this.form, {
            responses: this.criteria,
            status: "SUBMITTED"
          });

          FormService.update(this.form_id, this.form).then(res => {
            if (res.status == 200) {
              this.$buefy.toast.open({
                message: "Form published successfully.",
                type: "is-success"
              });

              this.files = [];
              this.$router.push({ path: '/forms'});
            }
            else {

              Object.assign(this.form, {status: 'DRAFT'});
            }

            vm.$store.dispatch('routeLoading', false);
          });
        })
        .catch(err => {

          // Can't think of why this would happen...
          // (we don't insist on GPS coordinates and catch failures above)
          vm.$buefy.toast.open('An error occurred while collecting GPS coordinates.');
        });
      }
    },
    onSaveAsDraft() {
      const vm = this;
      Object.assign(this.form, { responses: this.criteria });
      vm.markFormBusy();
      FormService.update(this.form_id, this.form).then(res => {
        switch (res.status) {
          case 200:
            this.$buefy.toast.open({
              message: "Draft saved successfully.",
              type: "is-info"
            });
            this.files = [];
            this.$router.push({ path: '/forms'});
            break;
        }
      })
      .finally(() => {
        vm.markFormBusy(false);
      });
    },
    onFileUpload(fileUploads = [], form_criteria_id, index) {
      var formData = new FormData();
      for (var i = 0; i < fileUploads.length; i++) {
        let f = fileUploads[i];
        formData.append("file[" + i + "]", f);
      }

      formData.append("disk", process.env.FILE_DISK);
      formData.append("status", "active");
      formData.append("form_criteria_id", form_criteria_id);
      formData.append("form_id", this.form_id);

      FileService.upload(formData).then(res => {
        switch (res.status) {
          case 201:
            // set something so it will validate
            this.criteria[index].values = 1;

            let files = this.criteriaFiles[index];

            files = files.concat(res.data);

            this.$set(this.criteriaFiles, index, files);

            this.$buefy.toast.open({
              duration: 1500,
              message: `File uploaded successfully (&times; ${
                fileUploads.length
              }).`,
              type: "is-success"
            });
            break;
        }
      });
    },
    enableChildrenInput(criterion) {
      let children = this.criteria.filter(v => v.parent_id == criterion.id);
      if (children.length) {
        let enable = false;
        switch (criterion.input_type) {
          case "dropdown":
            if (criterion.values == "please_select") {
              enable = false;
            } else {
              enable = true;
              // Check if there's an specific action for the selected option
              const option = criterion.input_type_options.find(v => v.value == criterion.values);
              if (option && option.action) {
                switch (option.action) {
                  case "enable":
                    enable = true;
                    break;
                  case "disable":
                    enable = false;
                    break;
                }
              }
            }
            break;
          default:
            // Enable if there's value. Disable if none
            enable = !!criterion.values;
        }
        children.map(v => {
          v.disabled = !enable;
          return v;
        });
      }
    },
    onInput: _.debounce(function(criterion) {
      this.enableChildrenInput(criterion);
      this.updateForm(this.form);
    }, 1000),
    updateForm: _.debounce(function(form) {
      const vm = this;

      // Skip save if it looks like this method may have been triggered
      // by the form re-population on initial page load mounted event.
      if ( ! vm.$data.initialLoadCompletedAt || Date.now() - vm.$data.initialLoadCompletedAt < 1250) {
        return false;
      }

      // Don't bother saving if the route is marked as busy loading
      // (user may have clicked publish and auto-save running late)
      if (vm.formIsBusy || vm.$store.getters['routeIsLoading']) {
        return false;
      }

      Object.assign(this.form, { responses: this.criteria });
      vm.markFormBusy();
      FormService.update(this.form_id, this.form)
        .then(something => {

          vm.$buefy.toast.open({
            message: "Changes saved.",
            type: "is-white.",
            position: 'is-top-right',
            duration: 1000
          });
        })
        .finally(() => {
          vm.markFormBusy(false);
        });
    }, 1000),
    onDeleteFile(file_id) {
      // Delete the file from the server
      FileService.delete(file_id).then(res => {
        let criteriaFilesNext = [];

        // Update this.criteriaFiles to reflect that the file has been deleted
        this.criteriaFiles.forEach((files, i) => {
          let keepFiles = files.filter((file, k) => {
            return file.id != file_id;
          });

          criteriaFilesNext[i] = keepFiles;
        });

        this.criteriaFiles = criteriaFilesNext;

        // Inform the user that the file was deleted
        this.$buefy.toast.open({
          duration: 1000,
          message: "File deleted successfully.",
          type: "is-success"
        });
      });
    },
    onReceivedAklcAssetMapPostMessage(payload) {

      const vm = this;

      this.asset_code = payload.SW_SAP_ID;
      this.$data.form.asset_code = payload.SW_SAP_ID;
      this.$data.form.asset_class = payload.asset_class;

      // Record asset coordinates if available
      const { geometry_x, geometry_y } = payload;

      let have_asset_coords = false;

      if (geometry_x && geometry_y && parseFloat(geometry_x) > 0) {

        const converted = proj4('NZTM', 'GPS', [geometry_x, geometry_y]);

        if (Array.isArray(converted) && converted[0] && converted[1]) {

          have_asset_coords = true;

          // Reminder: converted is [x,y] or [lng,lat] format
          this.$data.form.asset_lat = converted[1];
          this.$data.form.asset_lng = converted[0];
        }
      }

      this.$data.form.start_datetime = moment()
        .utc()
        .toISOString();

      if ( ! this.$data.form.completed_at) {

        this.$data.form.completed_at = moment().utc().toISOString();
      }

      this.$store.dispatch('routeLoading');

      this.attemptLocation({timeout: 10000})
        .then(position => {

          if (position) {

            vm.$data.form.device_accuracy_start = position.coords.accuracy;
            vm.$data.form.device_lat_start = position.coords.latitude;
            vm.$data.form.device_lng_start = position.coords.longitude;

            if ( ! have_asset_coords) {

              vm.$data.form.asset_lat = position.coords.latitude;
              vm.$data.form.asset_lng = position.coords.longitude;
            }
          }
          else {

            if ( ! have_asset_coords) {

              // Use Auckland City as default if neither asset or user coords available
              vm.$data.form.asset_lat = -36.846654;
              vm.$data.form.asset_lng = 174.754156;
            }
          }

          this.$store.dispatch('routeLoading', false);

          vm.updateForm(vm.$data.form);
        });

      this.updateForm(this.$data.form);
    },
    onReceivedGoogleAssetMapCoordinates(payload) {

      const vm = this;

      vm.$data.form.asset_lat = payload.lat;
      vm.$data.form.asset_lng = payload.lng;

      // Reset the asset_code field since the user is identifying a new asset
      // (the asset_code for a new asset is unknown until it gets created)
      this.asset_code = '';
      this.$data.form.asset_code = '';

      vm.$data.form.start_datetime = moment()
        .utc()
        .toISOString();

      this.updateForm(this.form);

      this.getLocation({ timeout: 10000 })
        .then(position => {
          vm.$data.form.device_accuracy_start = position.coords.accuracy;
          vm.$data.form.device_lat_start = position.coords.latitude;
          vm.$data.form.device_lng_start = position.coords.longitude;

          if ( ! vm.$data.form.completed_at) {

            vm.$data.form.completed_at = moment().utc().toISOString();
          }

          vm.updateForm(vm.form);
        })
        .catch(err => {
          // Not much we can do about this.
          this.$buefy.toast.open({
            duration: 3000,
            message: `Geolocation failed: ${err.message}`,
            type: "is-warning"
          });
        });
    },
    unixSeconds() {

      return moment().unix();
    },
    toggleUnixSwitch(criterion) {

      criterion.values = criterion.values ? '' : this.unixSeconds();

      // this.updateForm(this.form);
      this.onInput(criterion);
    },
    toggleTagSwitch(criterion) {
      // Assign tag_{tagname} to form->order (API)
      criterion.values = criterion.values ? '' : 1;
      // this.updateForm(this.form);
      this.onInput(criterion);
    },
    onMoveEnd(event) {
      this.lastClickPoint = null;
      this.assetIdForClickPoint = null;
      this.setLastKnownMapCenter(event.target.getCenter());
    },
    onMapReady(map) {
      const vm = this;
      this.setLastKnownMapCenter(map.getCenter());
      if (this.map_mode == 'ASSET_EXISTING') {
        // nothing for now
      }
      else if (this.map_mode == 'ASSET_NEW') {
        // Show marker at last specified coordinates if available
        if (this.form.asset_lat && this.form.asset_lng) {
          const latlng = {
            lat: parseFloat(this.form.asset_lat),
            lng: parseFloat(this.form.asset_lng),
          };
          this.$refs.mapAssetNew.$nextTick(() => {
            vm.$refs.mapAssetNew.setMarkerOnClick(latlng);
          });
        }
      }
    },
    transformFeature(feature) {
      const geo_type = _.get(feature, 'geometry.type');
      const coordinates = _.get(feature, 'geometry.coordinates');
      const code_name = _.get(feature, 'properties.asset_type_code');
      // Find first lat,lng pair in nested array {n} deep.
      let start_coordinates;
      let next = coordinates;
      while (Array.isArray(next)) {
        if ( ! Array.isArray(next[0])) {
          start_coordinates = {
            lng: next[0],
            lat: next[1]
          }
        }
        next = next[0];
      }
      if (
        (geo_type && geo_type.toUpperCase() == 'POINT')
        &&
        (code_name && code_name.toUpperCase() == 'CPIT')
      ) {
        // Convert CPIT to polygon so it shows up as a block on the map...
        const padding = 0.000015;
        let { lat, lng } = start_coordinates;
        feature.geometry.type = 'Polygon';
        feature.geometry.coordinates = [
          [
            [
              lng - padding,
              lat - padding
            ],
            [
              lng + padding,
              lat - padding
            ],
            [
              lng + padding,
              lat + padding
            ],
            [
              lng - padding,
              lat + padding
            ],
            [
              lng - padding,
              lat - padding
            ]
          ]
        ];
      }
      feature.properties.start_coordinates = start_coordinates
      return feature;
    },
    fetchAssetsAroundCenter(options) {
      const { coordinates } = options;
      return AssetService.geojson({
        centerY: coordinates.lat,
        centerX: coordinates.lng,
        outerRad: 0.2 + 0.2,
        // codeIds: [180]
      });
    },
    onAssetFeatureClicked(asset_id, event) {
      this.assetIdForClickPoint = asset_id;
      this.lastClickPoint = {
        lat: event.latlng.lat,
        lng: event.latlng.lng,
      };
    },
    onAssetCoordinatesClicked(event) {
      this.assetIdForClickPoint = null;
      this.lastClickPoint = {
        lat: event.latlng.lat,
        lng: event.latlng.lng,
      };
    },
    onAssetFeatureSelected(asset_id) {
      this.lastActiveFeatureId = asset_id;
      // Since the user clicked a feature, this should be a known asset.
      const assetFeature = this.assetsGeojson.features.find((f) => {
        return f.properties.asset_id == asset_id;
      });
      if (assetFeature) {
        const merge = {
          // REMINDER: The inspection forms currently only accept a single
          // lat+lng pair and since our assets include multi-coordinate
          // features like LineString & Polygon, we use a custom prop.
          // (also use custom prop since we convert CPIT to Polygon)
          asset_lat: _.get(assetFeature, 'properties.start_coordinates.lat'),
          asset_lng: _.get(assetFeature, 'properties.start_coordinates.lng'),
          asset_class: assetFeature.properties.asset_type_code,
          asset_code: assetFeature.properties.asset_third_party_code,
        };
        this.$set(this.$data, 'form', Object.assign({}, this.form, merge));
        this.afterNewOrExistingAssetSelected();
      }
    },
    onFreeClickCoordinates(event) {
      this.asset_code = ''; // unknown until eventually formalised in StormPort
      const merge = {
        asset_id: null,
        asset_code: '',
        asset_lat: event.latlng.lat,
        asset_lng: event.latlng.lng,
      }
      this.$set(this.$data, 'form', Object.assign({}, this.form, merge));
      this.afterNewOrExistingAssetSelected();
    },
    afterNewOrExistingAssetSelected() {
      // PLEASE NOTE: this method is meant to be called by the methods that handle
      // a click on either empty space (new asset) or a feature (existing asset).
      // It'll handle common logic like checking user position before finally
      // submitting the form to API for saving with known asset information.
      // console.log('afterNewOrExistingAssetSelected');

      const vm = this;
      let form_merge = {};
      this.$store.dispatch('routeLoading');
      this.attemptLocation({
        timeout: (vm.$store.state.environment == 'local')
          ? 3000
          : 10000
      })
        .then(position => {
          if (position) {
            form_merge['device_lat_start'] = position.coords.latitude;
            form_merge['device_lng_start'] = position.coords.longitude;
            form_merge['device_accuracy_start'] = position.coords.accuracy;
          }
          else {
            // Not much we can do about this.
            vm.$buefy.toast.open({
              duration: 3000,
              message: `Geolocation timeout.`,
              type: "is-warning"
            });
          }
          form_merge['start_datetime'] = moment().utc().toISOString();
          form_merge['completed_at'] = vm.form.completed_at
            ? vm.form.completed_at
            : moment().utc().toISOString();
          vm.$set(vm.$data, 'form', Object.assign({}, vm.form, form_merge));
          vm.updateForm(vm.$data.form);
          vm.$store.dispatch('routeLoading', false);
        });
    },
    setLastKnownMapCenter(latlng) {
      this.lastKnownMapCenter = latlng;
    },
    assetPopup(properties) {
      // Generate the div element that serves as a popup when
      // the user clicks on an asset in the loaded geojson.
      const asset_type_code = _.get(properties, 'asset_type_code');
      const asset_type_name = _.get(properties, 'asset_type_name');
      const asset_third_party_code = _.get(properties, 'asset_third_party_code');
      const content = document.createElement("div");
      content.innerHTML = `
        <span><b>ASSET ID</b>: ${asset_third_party_code || "N/A"}</span>
        <br>
        <span><b>ASSET CLASS</b>: ${
          asset_type_code
            ? `${asset_type_code} - ${asset_type_name}`
            : "N/A"
        }</span>
      `;
      return content;
    },
    onSelectOfferedAsset(feature) {
      this.assetIdForClickPoint = feature.properties.asset_id;
    },
    describeAssetFeature(feature) {
      const asset_type_code = _.get(feature, 'properties.asset_type_code');
      const asset_type_name = _.get(feature, 'properties.asset_type_name');
      const asset_third_party_code = _.get(feature, 'properties.asset_third_party_code');
      const parts = [
        asset_third_party_code || 'Missing Asset ID',
        asset_type_code ? `${asset_type_code} - ${asset_type_name}` : 'Missing Asset Class',
      ];
      return parts.join(' - ');
    },
    onConfirmProximityAssetSelection() {
      const selectedAssetId = this.assetIdForClickPoint;
      let assetFeature = this.assetsAroundClickPoint.find(a => a.properties.asset_id == selectedAssetId);
      if (assetFeature) {
        const merge = {
          // REMINDER: The inspection forms currently only accept a single
          // lat+lng pair and since our assets include multi-coordinate
          // features like LineString & Polygon, we use a custom prop.
          // (also use custom prop since we convert CPIT to Polygon)
          asset_id: _.get(assetFeature, 'properties.asset_id'),
          asset_lat: _.get(assetFeature, 'properties.start_coordinates.lat'),
          asset_lng: _.get(assetFeature, 'properties.start_coordinates.lng'),
          asset_class: assetFeature.properties.asset_type_code,
          asset_code: assetFeature.properties.asset_third_party_code,
        };
        this.$set(this.$data, 'form', Object.assign({}, this.form, merge));
        this.afterNewOrExistingAssetSelected();
      }
    },
    selectAsset(submit = true) {
      // this.form.asset_id = this.selectedAsset.id;
      // this.selectedAssetCode = this.selectedAsset.thirdPartyCode;
      // this.updateForm();

      const merge = {
        asset: this.selectedAsset,
        // REMINDER: The inspection forms currently only accept a single
        // lat+lng pair and since our assets include multi-coordinate
        // features like LineString & Polygon, we use a custom prop.
        // (also use custom prop since we convert CPIT to Polygon)
        asset_id: this.selectedAsset ? this.selectedAsset.id : "",
        asset_lat: this.selectedAsset
          ? this.selectedAsset.assetNodes[0].latitude
          : "",
        asset_lng: this.selectedAsset
          ? this.selectedAsset.assetNodes[0].longitude
          : "",
        asset_class:
          this.selectedAsset && this.selectedAsset.code
            ? this.selectedAsset.code.code
            : "",
        asset_code: this.selectedAsset ? this.selectedAsset.thirdPartyCode : "",
      };
      this.$set(this.$data, 'form', Object.assign({}, this.form, merge));
      if (submit) {
        this.afterNewOrExistingAssetSelected();
      }
    },
    async getAllowedAssetCodes() {
      try {
        const response = await FormService.listAssetCodes(this.form_id);
        this.allowedAssetCodes = JsonDenormalizer.denormalize(response);
      } catch (err) {
        throw err;
      }
    },
    markFormBusy(busy) {
      if (busy !== false) {
        this.formBusyCounter = this.formBusyCounter+1;
      }
      else {
        if (this.formBusyCounter >= 1) {
          this.formBusyCounter = this.formBusyCounter - 1;
        }
      }
    }
  }
};
</script>

<style scoped>
  .assets-nearest-click {
    border: 1px solid rgba(0,0,0,0.2);
    background-color: #fff;
    border-radius: 7px;
    position: absolute;
    min-width: 300px;
    /*padding: 1rem;*/
    z-index: 100;
    left: 5rem;
    top: 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/Forms/edit/index.vue